import aircraft from "../../../../resources/data/aeroplanes.json";
import aircraftCats from "../../../../resources/data/aeroplanesCats.json";
import roto from "../../../../resources/data/roto.json";
import rotoCats from "../../../../resources/data/rotoCats.json";

export const addAircraftType = ({ form, user, attachedItems, toast }) => {

    let aeroTP = user?.Ratings?.AeroplaneCategory === "None";
    let rotoTP = user?.Ratings?.HelicopterCategory === "None";

    let aircraftTypes = [
        ...(aeroTP ? aircraft : aircraftCats),
        ...(rotoTP ? roto : rotoCats)
    ].map(type => {
        return {
            "label": `${type.TCHolder} - ${type.Type}`,
            "id": `${type.TCHolder} - ${type.Type}`,
            "meta": type,
        };
    });

    form.setConfig({
        "title": "Add Aircraft Type",
        "type": "push",
        "location": `FlightTestCrew/${user.ID}/NewFlightHours`,
        "fields": [{
            "label": "Aircraft Type",
            "name": "Type",
            "type": "dropdown",
            "dropdownData": aircraftTypes
        }],
        preSubmitHook({ data, dropdownData }) {

            if (attachedItems.NewFlightHours.items.find(item => item.Type === data.Type)) {
                toast.error("You have already added this aircraft type");
                throw new Error("You have already added this aircraft type");
            }

            let selectedType = dropdownData.Type.find(t => t.id === data.Type);

            return {
                "Hours": 0,
                "Test": 0,
                "FlightHoursPIC": 0,
                "FlightHoursCO": 0,
                "FlightHoursPICTest": 0,
                "FlightHoursCOTest": 0,
                "LastUpdated": new Date().toISOString(),
                "CS": selectedType.meta.CS,
            }
        }
    });

    form.getDropdownData();

    form.toggle();
};

export const deleteAircraftType = async ({ form, user, rowItem, db }) => {

    form.setConfig({
        "title": "Delete Aircraft Type",
        "type": "delete",
        "location": `FlightTestCrew/${user.ID}/NewFlightHours/${rowItem.ID}`,
        "description": `Are you sure you want to delete ${rowItem.Type}?`
    });

    form.toggle();
};

export const editAircraftType = async ({ form, user, rowItem }) => {

    form.setValues(rowItem);

    form.setConfig({
        "title": `Add Flight Hours for ${rowItem.Type}`,
        "type": "update",
        "location": `FlightTestCrew/${user.ID}/NewFlightHours/${rowItem.ID}`,
        "fields": [{
            "label": "Total Flight Hours (All Time)",
            "info": "This is the total number of hours you have flown this aircraft type. This includes all PIC, CO, Test and Training hours.",
            "name": "Hours",
            "type": "number"
        }, {
            "label": "Test Flight Hours (All Time)",
            "info": "This is the total number of hours you have flown this aircraft type as a TEST pilot.",
            "name": "Test",
            "type": "number"
        }, {
            "type": "checkbox",
            "label": "Do you have more than 1000 hours as Pilot in Command?",
            "name": "MoreThan1000PiC",
            "info": "If you have more than 1000 hours as Pilot in Command, you can skip the next section.",
            "required": false
        }, {
            "type": "sectionHeader",
            "label": "Pilot in Command Hours - Last 12 Months",
            "divClass": "md:col-span-3"
        }, {
            "label": "Total PIC Hours (Last 12 Months)",
            "info": "This is the total number of hours you have flown this aircraft type as a pilot in command in the last 12 months as of today.",
            "name": "FlightHoursPIC",
            "type": "number"
        }, {
            "label": "Total PIC Test Hours (Last 12 Months)",
            "info": "This is the total number of hours you have flown this aircraft type as a TEST pilot in command in the last 12 months as of today.",
            "name": "FlightHoursPICTest",
            "type": "number"
        }, {
            "type": "sectionHeader",
            "label": "Co-Pilot Hours - Last 12 Months",
            "divClass": "md:col-span-3"
        }, {
            "label": "Total CO Hours (Last 12 Months)",
            "info": "This is the total number of hours you have flown this aircraft type as a co-pilot in the last 12 months as of today.",
            "name": "FlightHoursCO",
            "type": "number"
        }, {
            "label": "Total CO Test Hours (Last 12 Months)",
            "info": "This is the total number of hours you have flown this aircraft type as a TEST co-pilot in the last 12 months as of today.",
            "name": "FlightHoursCOTest",
            "type": "number"
        }],
        preSubmitHook() {
            return {
                "LastUpdated": new Date().toISOString(),
            };
        }
    });

    form.toggle();
};
